import { render, staticRenderFns } from "./voucher.vue?vue&type=template&id=0298b7b8&scoped=true"
import script from "./voucher.vue?vue&type=script&lang=js"
export * from "./voucher.vue?vue&type=script&lang=js"
import style0 from "./voucher.vue?vue&type=style&index=0&id=0298b7b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0298b7b8",
  null
  
)

export default component.exports